import React from "react";
import { company, navLinks, services } from "../mock";
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";

const socials = [
  { id: "sm-fb", Icon: Facebook, href: "#" },
  { id: "sm-tw", Icon: Twitter, href: "#" },
  { id: "sm-in", Icon: Linkedin, href: "#" },
  { id: "sm-ig", Icon: Instagram, href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img
            src={company.logo}
            alt={`${company.name} logo`}
            className="h-14 w-auto object-contain"
            style={{ maxWidth: 260 }}
          />
          <p className="mt-4 text-sm text-gray-600 leading-relaxed">Talent acquisition, corporate training, and BPO solutions built for growth-focused businesses.</p>
          <div className="mt-5 flex gap-3">
            {socials.map(({ id, Icon, href }) => (
              <a key={id} href={href} aria-label="social" className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-brand hover:text-white hover:border-brand">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-bold text-gray-900 uppercase text-xs tracking-widest">Quick Links</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}><a href={l.href} className="text-gray-600 hover:text-brand">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-gray-900 uppercase text-xs tracking-widest">Services</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {services.map((s) => (
              <li key={s.id}><a href="#services" className="text-gray-600 hover:text-brand">{s.title}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-gray-900 uppercase text-xs tracking-widest">Contact</h4>
          <ul className="mt-5 space-y-4 text-sm text-gray-600">
            <li className="flex items-start gap-2"><Mail size={16} className="text-brand mt-0.5" /><a href={`mailto:${company.email}`} className="hover:text-brand">{company.email}</a></li>
            <li className="flex items-start gap-2"><Mail size={16} className="text-brand mt-0.5" /><a href={`mailto:${company.careerEmail}`} className="hover:text-brand">{company.careerEmail}</a></li>
            <li className="flex items-start gap-2"><Phone size={16} className="text-brand mt-0.5" /><a href={`tel:${company.phone}`} className="hover:text-brand">{company.phone}</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="text-brand mt-0.5" /><span>{company.locations}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} {company.name}. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-brand">Privacy Policy</a>
            <a href="#" className="hover:text-brand">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
